<template>
  <div>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('meta.costCenters'), name: 'cost_centers' }, { text: costCenterFrozenName }]"
        />
      </template>
      <template v-slot:meta>
        <button
          v-if="costCenter.archived"
          @click="unarchiveCostCenter"
          class="button button-green button-small button-round"
        >
          {{ $t('costCenters.unarchive') }}
        </button>
        <button
          v-else-if="costCenter.can_be_deleted"
          @click="deleteCostCenter"
          class="button button-red button-small button-round"
        >
          {{ $t('costCenters.delete') }}
        </button>
        <button v-else @click="archiveCostCenter" class="button button-red button-small button-round">
          {{ $t('costCenters.archive') }}
        </button>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('meta.baseData') }}</h3>
            <div class="header-meta"></div>
          </header>
          <div class="content-body">
            <LoadingSpinner v-if="loading" />
            <Form v-else :value="costCenter" @submit="updateCostCenter" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/companies/cost_centers/Form'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import costCentersApi from '@/api/costCenters'

export default {
  name: 'new_cost_center',
  inject: ['companyUser', 'showPopup'],
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    Form,
    SectionHeader,
  },
  data() {
    return {
      loading: true,
      costCenter: {},
      costCenterFrozenName: null,
    }
  },
  methods: {
    updateCostCenter: async function (costCenter) {
      const updatedCostCenter = await costCentersApi.update(costCenter.uuid, costCenter)

      if (updatedCostCenter) {
        await this.$router.push('/company/cost_centers')
      }
    },
    async deleteCostCenter() {
      const confirmAlert = await this.showPopup({ content: this.$t('costCenters.deleteConfirmation'), type: 'confirm' })
      if (!confirmAlert) return null

      const result = await costCentersApi.delete(this.costCenter.uuid)
      if (result.success) this.$router.push({ name: 'cost_centers' })
    },
    async archiveCostCenter() {
      const confirmAlert = await this.showPopup({
        content: this.$t('costCenters.archiveConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return null

      const result = await costCentersApi.archive(this.costCenter.uuid)
      if (result.success) this.$router.push({ name: 'cost_centers' })
    },
    async unarchiveCostCenter() {
      const result = await costCentersApi.unarchive(this.costCenter.uuid)
      if (result.success) this.$router.push({ name: 'cost_centers' })
    },
  },
  async mounted() {
    this.costCenter = await costCentersApi.get(this.$route.params.cost_center_uuid)
    this.costCenterFrozenName = this.costCenter.name
    this.loading = false
  },
}
</script>
